import { render } from "./navbar.vue?vue&type=template&id=8b2ca992&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "../assets/css/navbar.css?vue&type=style&index=0&id=8b2ca992&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2ca992"]])

export default __exports__